import { Ban, History, Lock, Pencil, Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useHasPermission } from "@/hooks/use-auth";

import type { RiderSale } from "@artisancode/api-types";

export function RiderSaleRowActions({
  item,
  canUpdate,
  canDelete,
  canVoid,
  onEdit,
  onDelete,
  onVoid,
  onHistory,
}: {
  item: RiderSale;
  canUpdate: boolean;
  canDelete: boolean;
  canVoid: boolean;
  onEdit: (item: RiderSale) => void;
  onDelete: (item: RiderSale) => void;
  onVoid: (item: RiderSale) => void;
  onHistory?: (item: RiderSale) => void;
}) {
  const canViewLogs = useHasPermission("rider_sales.view");

  if (item.locked) {
    return (
      <div className="flex items-center gap-1">
        <div
          className="flex items-center gap-1 text-muted-foreground"
          title="Sudah dipilih ke Penggajian Rider — batalkan payroll-nya dulu untuk mengubah/menghapus"
        >
          <Lock className="h-3.5 w-3.5" />
          <span className="text-xs">Dari Payroll</span>
        </div>
        {canViewLogs && onHistory && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onHistory(item)}
            title="Riwayat Aktivitas"
            aria-label="Riwayat Aktivitas"
          >
            <History className="h-4 w-4" />
            <span className="sr-only">Riwayat Aktivitas</span>
          </Button>
        )}
      </div>
    );
  }

  // Only draft is still editable — done/paid are final (bonus/payroll already
  // depend on the snapshot), cancelled is dead. Correct a mistake there via
  // Void instead of reopening it.
  const isDraft = item.status === "draft";

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onEdit(item)}
        disabled={!canUpdate || !isDraft}
      >
        <Pencil className="h-4 w-4" />
      </Button>
      {isDraft ? (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onDelete(item)}
          disabled={!canDelete}
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      ) : (
        item.status !== "cancelled" && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onVoid(item)}
            disabled={!canVoid}
            title="Void / batalkan transaksi"
          >
            <Ban className="h-4 w-4" />
          </Button>
        )
      )}
      {canViewLogs && onHistory && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onHistory(item)}
          title="Riwayat Aktivitas"
          aria-label="Riwayat Aktivitas"
        >
          <History className="h-4 w-4" />
          <span className="sr-only">Riwayat Aktivitas</span>
        </Button>
      )}
    </div>
  );
}
